import * as React from 'react';
import * as URI from 'urijs';
import { translate } from 'components/translate-hoc';

import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';

import { COPY_KEY_BUTTON_ANALYTICS, SHARE_LINK_QUERY_PARAM, TEXT_KEYS } from './share-link.constants';
import { IShareLinkProps } from './share-link.types';

import './share-link.styles.less';
import { getModeClass } from 'utils/css';

export class ShareLink extends React.Component<IShareLinkProps> {
    public renderShareLinkInput(): JSX.Element {
        const { dangerouslyTranslateWithHTML: translateKey, shouldInheritStyles } = this.props;
        const currentURL = new URI(window.location.href);
        const validSegments = currentURL.segment().filter(segment => segment !== this.props.activeLanguageCode);
        const fullLink = new URI(currentURL.origin()).segment(validSegments).addQuery({
            [SHARE_LINK_QUERY_PARAM]: this.props.invitationId
        }).href();
        const buttonText = translateKey(TEXT_KEYS.COPY_BUTTON);
        const basePageStyleClass = getModeClass('sitegen-fr-share-link', shouldInheritStyles);

        /* This should be calculated only once, so inline callback is OK */
        const callback = (): void => {
            navigator.clipboard.writeText(fullLink).then(() => {
                AnalyticsService.sendFlowEvent(COPY_KEY_BUTTON_ANALYTICS);
            },
            (err) => {
                // eslint-disable-next-line no-console
                console.error('Could not copy into clipboard: ', err);
            });
        };

        return (
            <div className={`${basePageStyleClass}__wrapper`}>
                <div className={`${basePageStyleClass}__block-with-link`}>{fullLink}</div>
                <div className={`${basePageStyleClass}__copy-button`} onClick={callback}>
                    {buttonText}
                </div>
            </div>
        );
    }

    public render() {
        const { dangerouslyTranslateWithHTML: translateKey, shouldInheritStyles } = this.props;
        const titleText = translateKey(TEXT_KEYS.TITLE);
        const descriptionText = translateKey(TEXT_KEYS.DESCRIPTION);
        const warningText = translateKey(TEXT_KEYS.WARNING);
        const basePageStyleClass = getModeClass('sitegen-fr-share-link', shouldInheritStyles);

        return (
            <div className={basePageStyleClass}>
                <div className={`${basePageStyleClass}__title`}>
                    {titleText}
                </div>
                <div className={`${basePageStyleClass}__description`}>
                    {descriptionText}
                </div>
                {this.renderShareLinkInput()}
                <div className={`${basePageStyleClass}__warning`}>
                    <span className={`${basePageStyleClass}__warning-icon`}>
                    </span>
                    {warningText}
                </div>
            </div>
        );
    }
}

export default translate()(ShareLink);
